(() => {
  const elementName = 'tinto-genova-carousel';
  if (customElements.get(elementName)) return;

  class TintoGenovaCarousel extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._viewport = this.querySelector('[data-carousel-viewport]');
      this._slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this._indicators = Array.from(this.querySelectorAll('[data-carousel-indicator]'));
      this._status = this.querySelector('[data-carousel-status]');
      this._previous = this.querySelector('[data-carousel-previous]');
      this._next = this.querySelector('[data-carousel-next]');
      this._current = 0;
      this._raf = 0;

      if (!this._viewport || this._slides.length !== 3 || this._indicators.length !== 3) return;

      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this._previous.addEventListener('click', () => this.goTo(this._current - 1), options);
      this._next.addEventListener('click', () => this.goTo(this._current + 1), options);
      this._indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => this.goTo(index), options);
      });
      this._viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.updateFromScroll());
      }, { passive: true, signal: this._controller.signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.updateState(0, false);
    }

    disconnectedCallback() {
      if (this._controller) this._controller.abort();
      cancelAnimationFrame(this._raf);
      this._controller = null;
      this._initialized = false;
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this._current - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.goTo(this._current + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.goTo(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.goTo(this._slides.length - 1);
      }
    }

    goTo(index) {
      const target = (index + this._slides.length) % this._slides.length;
      const image = this._slides[target].querySelector('img[loading="lazy"]');
      if (image) image.loading = 'eager';
      this._viewport.scrollTo({
        left: this._slides[target].offsetLeft,
        behavior: 'auto'
      });
      this.updateState(target, true);
    }

    updateFromScroll() {
      const left = this._viewport.scrollLeft;
      let closest = 0;
      let distance = Infinity;
      this._slides.forEach((slide, index) => {
        const candidate = Math.abs(slide.offsetLeft - left);
        if (candidate < distance) {
          distance = candidate;
          closest = index;
        }
      });
      this.updateState(closest, closest !== this._current);
    }

    updateState(index, announce) {
      this._current = index;
      this._slides.forEach((slide, slideIndex) => {
        if (slideIndex === index) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this._indicators.forEach((indicator, indicatorIndex) => {
        if (indicatorIndex === index) indicator.setAttribute('aria-current', 'true');
        else indicator.removeAttribute('aria-current');
      });
      if (this._status && (announce || !this._status.textContent)) {
        const spoken = `Diapositiva ${index + 1} de ${this._slides.length}`;
        this._status.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this._slides.length).padStart(2, '0')}`;
        this._status.setAttribute('aria-label', spoken);
      }
    }
  }

  customElements.define(elementName, TintoGenovaCarousel);
})();
